import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom'
import Select from 'react-select';
import HttpClient from '../utils/HttpClient';
import DataTable from 'react-data-table-component';
const AssignProjectToUser = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [allUsersList, setAllUsersList] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');

    const locationState = location?.state
    console.log("sd5fs31d", locationState)



    // Columns Definition
    const columns = [
        {
            name: 'SL',
            selector: row => row.sl,
            sortable: true,
            wrap: true
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
            wrap: true
        },
        {
            name: 'Email-ID',
            selector: row => row.emailID,
            sortable: true,
            wrap: true
        },
        {
            name: 'Organization-Name',
            selector: row => row.organizationName,
            sortable: true,
            wrap: true
        },
        {
            name: 'Address',
            selector: row => row.address,
            sortable: true,
            wrap: true
        },
        {
            name: 'Image',
            selector: row => row.image,
            sortable: true,
            wrap: true
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
            wrap: true
        },
        // {
        //     name: 'Action',
        //     cell: row => (
        //         <Dropdown>
        //             <Dropdown.Toggle variant="link" id="dropdown-basic" style={{ border: 'none', boxShadow: 'none', textDecoration: "none", color: "rgb(208, 38, 38)" }}>
        //                 <i className="fa-solid fa-ellipsis-v" style={{ cursor: 'pointer' }} onClick={() => handleIconClick(row.sl)}></i>
        //             </Dropdown.Toggle>
        //             <Dropdown.Menu className="tooltip-modal">
        //                 <Dropdown.Item className='tooltipBtn' onClick={() => handleEdit(row)}>Edit</Dropdown.Item>
        //                 <Dropdown.Item className='tooltipBtn' onClick={() => handleDelete(row)}>Delete</Dropdown.Item>
        //                 <Dropdown.Item className='tooltipBtn' onClick={() => handleActiveInactive(row, row?.action?.status === "Active" ? "Inactive" : "Active")}>{row.action?.status === "Active" ? "Inactive" : "Active"}</Dropdown.Item>
        //                 <Dropdown.Item className='tooltipBtn' onClick={() => handleEditPassword(row?.action)}> <i className="fa-solid fa-pen-to-square mr-1"></i>Password</Dropdown.Item>
        //             </Dropdown.Menu>
        //         </Dropdown>
        //     ),
        //     sortable: false,
        //     wrap: true,
        // },
    ];

    // >>>>Handle Back click<<<<
    const handleBackClick = () => {
        navigate(-1);
    };

    // >>>>Formating the option<<<<
    const formatOptions = (data) => {
        return data?.map(user => ({
            value: user._id,
            label: `${user.firstName} ${user.lastName} (${user?.emailID})`
        }));
    };

    // >>>>Fetch User Data<<<<
    const fetchAllUsers = async () => {
        try {
            const res = await HttpClient.requestData("user-list", "GET");
            if (res && res?.status) {
                setAllUsersList(res?.data);
                setOptions(formatOptions(res?.data)); // Update options state with formatted data
            } else {
                toast.error("Failed to fetch user data.");
            }
        } catch (error) {
            toast.error("An error occurred while fetching user data.");
        }
    };

    // >>>>Handle Select change<<<<
    const handleSelectChange = (selectedOption) => {
        setSelectedUser(selectedOption);
    };

    // >>>>Handle Add User<<<<
    const handleAddUserClick = async () => {
        if (!selectedUser) {
            return toast.error("Please select a user...!")
        } else {
            const data = {
                projectID: locationState?.id,
                userID: selectedUser?.value
            }
            console.log("SelectedUser", data, selectedUser);
            const res = await HttpClient.requestData("project-assign", "POST", data);
            if (res && res?.status) {
                toast.success(res?.message || "Project assign successfully...!")
                setSelectedUser(null)
            } else {
                return toast.error(res?.message || "Something went wrong...!")
            }
        }
    };

    useEffect(() => {
        fetchAllUsers()
    }, [])
    return (
        <div className='manageUsers'>

            {/* Headers */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h3 style={{ fontSize: "20px" }}>Manage Project Users</h3>
                <b className='back'
                    onClick={handleBackClick}
                    style={{ color: "rgb(208, 38, 38)", cursor: "pointer" }}>
                    <i className="fas fa-arrow-left" style={{ marginRight: '8px' }}></i>
                    Back
                </b>
            </div>

            {/* Select Input */}
            <div className='d-flex gap-3 mt-3'>
                <Select
                    className='w-50'
                    value={selectedUser}
                    onChange={handleSelectChange}
                    options={options}
                    placeholder="Select User"
                />

                <button className='btn' type='submit' onClick={handleAddUserClick} style={{ backgroundColor: "#0a5688", color: "#fff" }}>Add User</button>
            </div>

            {/* DataTable */}
            <div className='mt-5 shadow-lg'>
                {/* Search Input */}
                <div className="header-container Search_box d-flex justify-content-start p-2">
                    <form className="form-inline" style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.5)" }} onSubmit={(e) => e.preventDefault()}>
                        <input
                            className="form-control"
                            type="search"
                            placeholder="Search by user name..."
                            aria-label="Search"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <button className="Search_icon" type="submit">
                            <i className="fa-solid fa-magnifying-glass"></i>
                        </button>
                    </form>
                </div>
                <DataTable
                    columns={columns}
                    // data={searchUser}
                    pagination={true}
                    responsive={true}
                    highlightOnHover={true}
                />
            </div>
        </div>
    )
}

export default AssignProjectToUser